var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWalletBybit = function SvgIcWalletBybit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_wallet_bybit_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic_wallet_bybit_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ic_wallet_bybit_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0V0Z",
    fill: "#404347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.721 6.093a1.112 1.112 0 0 1 .837-1.397L13.094 2.46a1.111 1.111 0 0 1 1.23.602l4.732 9.772L5.72 19.889l-4-13.796Z",
    fill: "url(#ic_wallet_bybit_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.86 6.855a1.111 1.111 0 0 1 .924-1.41l13.963-1.811a1.111 1.111 0 0 1 1.233.885L20 14.723 5.61 19.833 1.86 6.856Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.778a2.222 2.222 0 0 1 2.222-2.222h13.334A4.444 4.444 0 0 1 20 10v10H0V7.778Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.636 13.639v-3.396h.663v3.396h-.663Z",
    fill: "#F7A600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.077 14.653H3.655v-3.397h1.363c.663 0 1.049.372 1.049.954 0 .377-.248.62-.42.702.206.095.468.31.468.763 0 .634-.434.978-1.04.978m-.11-2.805h-.647v.782h.648c.281 0 .439-.157.439-.39 0-.235-.158-.392-.44-.392Zm.043 1.379h-.69v.834h.691c.3 0 .443-.19.443-.42 0-.229-.143-.414-.444-.414Zm2.933.032v1.394h-.659V13.26l-1.02-2.004h.72l.634 1.37.625-1.37h.72l-1.02 2.003Zm2.905 1.394h-1.42v-3.397h1.363c.662 0 1.048.372 1.048.954 0 .377-.248.62-.42.702.206.095.468.31.468.763 0 .634-.434.978-1.04.978Zm-.11-2.805h-.649v.782h.649c.28 0 .438-.157.438-.39 0-.235-.157-.392-.438-.392Zm.043 1.379h-.691v.834h.69c.301 0 .444-.19.444-.42 0-.229-.143-.414-.443-.414Zm4.678-1.38v2.806h-.662v-2.805h-.886v-.592h2.435v.592h-.887Z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic_wallet_bybit_svg__c",
    x1: 1.666,
    y1: 5.817,
    x2: 19.236,
    y2: 4.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_wallet_bybit_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#fff"
  })))));
};
export default SvgIcWalletBybit;